import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Field, change, getFormValues } from 'redux-form';

import Select from '../Select';
import { getDefaultDietRestrictionId } from '../../apiHelpers';
import withLocalize from '../../withLocalize';
import T from '../Translate';

class DietRestrictionGuest extends Component {

	componentDidMount() {
		const { index, value, defaultDietRestrictionId, dispatch } = this.props;

		if (!value && defaultDietRestrictionId) {
			dispatch(change('bookingForm', `dietRestriction[${index}]`, defaultDietRestrictionId));
		}
	}

	render() {
		const { index, dietRestrictions, translatePropertyValue } = this.props;

		const options = Object.values(dietRestrictions).map(dietRestriction => ({
			value: dietRestriction.id,
			label: translatePropertyValue(dietRestriction.name),
		}));

		return (
			<div className="fieldset__fields-row">
				<Field
					component={Select}
					name={`dietRestriction[${index}]`}
					label={<T id="GuestDetails.guest" data={{ count: index + 1 }} />}
					options={options}
				/>
			</div>
		);
	}
}

export default compose(
	connect((state, props) => ({
		value: ((getFormValues('bookingForm')(state) || {}).dietRestriction || [])[props.index],
		dietRestrictions: state.app.dietRestrictions || {},
		defaultDietRestrictionId: getDefaultDietRestrictionId(state.app.dietRestrictions),
	})),
	withLocalize,
)(DietRestrictionGuest);



// WEBPACK FOOTER //
// ./src/components/DietRestrictions/DietRestrictionGuest.jsx